module.exports = __webpack_public_path__ + "media/products/caret-up-c7c0a176.svg";